<template>
  <div class="share-page height100">
    <img class="background-img" src="@/assets/image/光荣榜.png" alt="">
    <div class="buttom" :style="{'height': backgroundHeight + 'px'}">
      <!-- <img v-if="flag === 1" class="button" @click="clickHandle" src="@/assets/image/button立即预约.png" alt=""> -->
      <!-- <img v-else class="button" @click="clickHandle" src="@/assets/image/button.png" alt=""> -->
      <!-- <p class="buttom-tip-text">参与活动需要将企鹅汇图App升级到V3.8.0及以上版本</p> -->
    </div>
  </div>
</template>

<script>
import { defineComponent, getCurrentInstance, onMounted, reactive, toRefs, } from 'vue';
import { commonShare, timeNode, isPro, getSource } from '@/utils/index.js';

export default defineComponent({
  setup() {
    const { beacon } = getCurrentInstance().appContext.config.globalProperties;
    const { proxy } = getCurrentInstance();
    const data = reactive({
      flag: 0,
      backgroundHeight: 0,
    });
    onMounted(() => {
      // window.console.log(beacon.getDeviceId());
      data.flag = timeNode();
       beacon.onUserAction('activity_show', {
          source: getSource(),
        });
      // beacon.onUserAction('activity_show', {
      //   source: getSource(),
      // });
      //  window.console.log(getSource(),'getSource()');
      document.querySelector('.background-img').onload = function() {
        data.backgroundHeight = window.innerHeight - this.height;
      };
    });
    const clickHandle = () => {
     const shareUrl = isPro() ? 'https://huituactivity.map.qq.com/' : 'https://huituactivitytest.map.qq.com/';
      if (data.flag === 3) return proxy.$toast.text('活动已结束');
      commonShare(
        `htscheme://com.tencent.easyearn/activity?page_type=104&extra_params={'type':3,'activityId':5555,'url':'${shareUrl}?from=${getSource()}','time':${new Date().getTime()}}`,
        beacon,
      );
    };
    return {
      ...toRefs(data),
      clickHandle,
    };
  },
})
</script>

<style lang="scss" scoped>
.share-page {
    background-color: #703ced;
  font-size: 0;
  width: 100%;
  position: relative;
  // display: flex;
  // justify-content: center;
  // align-items: center;
  .background-img {
    width: 100%;
    // height: 100%;
  }
  .buttom {
    
    width: 100%;
    min-height: 110px;
    background-color: #703ced;
    position: relative;
    .button {
      width: 352.73px;
      position: absolute;
      top: 0;
      left: 50%;
      transform: translateX(-50%);
    }
    .buttom-tip-text {
      white-space: nowrap;
      font-size: 11px;
      color: #AB3600;
      position: absolute;
      top: 70px;
      left: 50%;
      transform: translateX(-50%);
    }
  }
}
</style>
